var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.02 22.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #06513d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.02,22.04c0,.14-.19.3-.33.3h-10.83s.03-.25.03-.25v-2.41c.23-.21.39-.47.39-.78v-4.66c0-.59-.46-1.04-1.04-1.05h-1.16c.82-1.41,2.24-2.29,3.84-2.41l1.91,2.74-1.1,5.56c-.04.14,0,.3.08.4l1.11,1.18c.11.11.35.19.48.06l1.11-1.17c.1-.11.17-.23.15-.39l-1.11-5.63,1.9-2.74c2.43.17,4.44,2.18,4.52,4.67l.03,6.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.16,4.96c0,2.74-2.22,4.96-4.96,4.96s-4.96-2.22-4.96-4.96S12.46,0,15.2,0s4.96,2.22,4.96,4.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.2,13.88h-3.04s0-1.16,0-1.16c0-.22-.14-.39-.37-.39h-3.03c-.19,0-.34.16-.34.35v1.21s-3.06,0-3.06,0c-.17,0-.36.12-.36.31v4.71c0,.16.14.33.32.33h9.92c.2,0,.35-.15.35-.34v-4.65c0-.24-.17-.37-.39-.37ZM4.11,13.88v-.87s2.35,0,2.35,0v.87s-2.35,0-2.35,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.21,22c0,.17-.11.3-.31.34H.68c-.18-.04-.31-.17-.31-.35v-2.08s9.83,0,9.83,0v2.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15.97 19.13 15.2 19.94 14.43 19.13 15.2 15.27 15.97 19.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.64 10.77 15.2 12.84 13.76 10.77 16.64 10.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.47 13.88 4.11 13.88 4.11 13.01 6.47 13.01 6.47 13.88"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee);
export default __webpack_public_path__ + "static/media/Employee.3894f6e6b15299e7123f632eb9485776.svg";
export { ForwardRef as ReactComponent };